import { formatDate, formatDateUtc } from '@main/shared/utils';
import dayjs from 'dayjs';
import { useEffect, useMemo, useState } from 'react';

export function useAddDayjs(value: number, unit?: dayjs.ManipulateType, template?: string) {
  return useMemo(() => dayjs().add(value, unit).format(template), [value, unit, template]);
}

export function useHydratedDate(date?: string | Date | null, format?: string) {
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => setHydrated(true), []);

  return hydrated ? formatDate(date, format) : formatDateUtc(date, format);
}
